import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RdDialogComponent } from '../../rd-dialog/rd-dialog.component';
import { MemberService } from 'src/app/services/member.service';
import { of, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { NDDFunction } from 'src/app/models/modelNDD';
import { AdminService } from 'src/app/services/admin.service';

export interface NDDOpenForArticle {
  FILEFLAG: string;
  COPYFLAG: string;
  REALITEMFLAG: string;
  ITEMID: string,
  PAGE: string,
  PAGECOUNT: number
  LOCATIONID: string
}

@Component({
  selector: 'app-btn-rd',
  templateUrl: './btn-rd.component.html',
  styleUrls: ['./btn-rd.component.css'],
})
export class BtnRDComponent implements OnInit {
  @Input() item: any;
  @Input() BLOCKUSER: boolean;
  @Input() mattypeID: string;
  @Input() NDDUserPrivilege: boolean;

  USERID: string = '';
  currentUser: any[] = [];

  _openRD: boolean = false; // ใช้สำหรับเปิดปิด RD OPAC จาก  lib_opacconfig
  NDDTypeOpen = false;
  NDDTypeOpenSubcription: Subscription = new Subscription();
  calPageCountAndFeeSubcription: Subscription = new Subscription();
  
  NDDForArticle: NDDOpenForArticle = {
    FILEFLAG: '',
    COPYFLAG: '',
    REALITEMFLAG: '',
    ITEMID: '',
    PAGE: '',
    PAGECOUNT: 0,
    LOCATIONID: ''
  };

  isArticle: boolean = false

  fc = new NDDFunction(this.homeService);
  baseHref: string = '';
  _CheckOpenRDByCollection: boolean = false;

  constructor(
    private router: Router,
    private homeService: HomeService,
    private modalService: NgbModal,
    private memberService: MemberService,
    private adminservice: AdminService,
  ) {
     this.baseHref = document.getElementsByTagName('base')[0].getAttribute('href') || '';
  }

  ngOnDestroy(): void {
    if (this.NDDTypeOpenSubcription) {
      this.NDDTypeOpenSubcription.unsubscribe();
    }
    if (this.calPageCountAndFeeSubcription) {
      this.calPageCountAndFeeSubcription.unsubscribe();
    }
  }

  async ngOnInit(): Promise<void> {
     //open RD OPAC
      this.adminservice.GetOpacConfigValue('NewDD').subscribe(async (config: any) => {
          if (config) {
            this._openRD = config;
            if (typeof this.item == 'string' && this.item.includes('j')) {
              await this.CheckNDDTypeOpenForArticle();
            } else {
              this.NDDTypeOpen = await this.CheckNDDTypeOpen(
                this.item.LOCATIONID
              );
              this.isArticle = false;
              this.checkpenByCollection();
            }
          }
      });

   

    /*ตรวจสอบ user login*/
    this.currentUser = JSON.parse(localStorage.getItem('WALAIcurrentUser')) || [];

    // ถ้าไม่ login จะทำให้ปุ่ม RD ไม่แสดง
    // if (this.currentUser.length != 0) {
    //   this.USERID = this.currentUser[0].USERID;
    //   this.checkpenByCollection();
    // }

    
  }


  checkpenByCollection() {
    return new Promise<boolean>((resolve) => {
      this.homeService
            .getNDDRequestTypeOpen(this.item.ITEMID)
            .subscribe((requesttype: any) => {
              let FlagNDDCOUNTOPEN =
                Number(requesttype[0].REALITEMFLAG) +
                Number(requesttype[0].COPYFLAG) +
                Number(requesttype[0].FILEFLAG);
              this._CheckOpenRDByCollection = FlagNDDCOUNTOPEN > 0;
              resolve(this._CheckOpenRDByCollection);
      });
    });
  }

  async openRD(item: any) {
    let val = encodeURIComponent(`${this.baseHref}${this.router.url}`);
    let url = `<a class="text-primary fs-5" href="${this.baseHref}login?redirectURL=${val}">เข้าสู่ระบบ</a>`;
    let msgUseRD = 'สมาชิกห้องสมุดเท่านั้นที่สามารถใช้งานฟังก์ชัน Resource delivery ได้!';
    let msgBlockUser = 'ไม่สามารถขอส่งได้: สมาชิกถูกบล็อก!';
    let msgUsePrivilege = 'ไม่สามารถขอส่งได้: ประเภทสมาชิกนี้ไม่อนุญาต!';
    let msgRDClose = 'ไม่เปิดใช้งานระบบ Resource delivery!';

    if(localStorage.getItem('lang') == 'en'){
      url = `<a class="text-primary fs-5" href="${this.baseHref}login?redirectURL=${val}">Login</a>`;
      msgUseRD = 'Only library members can use the Resource delivery function!';
      msgBlockUser = 'Unable to request delivery: Member is blocked!';
      msgUsePrivilege = 'Unable to request delivery: This member type is not allowed!';
      msgRDClose = 'Resource delivery system is not enabled!';
    }
    /*ตรวจสอบ user login*/
    this.currentUser = JSON.parse(localStorage.getItem('WALAIcurrentUser')) || [];

    if (this.currentUser.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: msgUseRD,
        // text:  msgUseRD,
        footer: url,
      });
    } else {
      if (this.BLOCKUSER == true) {
        Swal.fire({
          icon: 'warning',
          title: msgBlockUser,
          // text: msgBlockUser,
        });
        return;
      }

      if (this.NDDUserPrivilege == false) {
        Swal.fire({
          icon: 'warning',
          title: msgUsePrivilege,
          // text: msgUsePrivilege,
        });
        return;
      }

      //article
      if (typeof this.item == 'string' && this.item.includes('j')) {
        let FlagNDDCOUNTOPEN =
          Number(this.NDDForArticle.FILEFLAG) +
          Number(this.NDDForArticle.COPYFLAG) +
          Number(this.NDDForArticle.REALITEMFLAG);

        if (FlagNDDCOUNTOPEN > 0) {
          
        let _respponse: any

         this.homeService.getJMarcPage(this.item).subscribe({
            next: (res: any) => {
              _respponse = res.status == 200? res.body: false
            },
             complete: async () => {

              if(_respponse == false){
                Swal.fire({
                  icon: 'warning',
                  title: `${item} ${msgRDClose}`,
                  // text: `${item} ${msgRDClose}`,
                });

                return
              }
              

              this.NDDForArticle.PAGE =  _respponse[0].PAGE == ''? 1: _respponse[0].PAGE;
              this.NDDForArticle.PAGECOUNT = this.NDDForArticle.PAGE != ''? await this.fc.calPageCount(this.NDDForArticle.PAGE) : 1
              this.NDDForArticle.LOCATIONID = this.currentUser[0].LOCATIONID;
                const modalRef = this.modalService.open(RdDialogComponent, {size: 'md'});
                modalRef.componentInstance.dataRD = this.NDDForArticle;
                modalRef.componentInstance.mattypeID = this.mattypeID;
            },
        })

        } else {

          Swal.fire({
            icon: 'warning',
            title: `${item} ${msgRDClose}`,
            // text: `${item} ${msgRDClose}`,
          });

        }


      } else {

        //item
        this.homeService
          .getNDDRequestTypeOpen(item.ITEMID)
          .subscribe((requesttype: any) => {
            let FlagNDDCOUNTOPEN =
              Number(requesttype[0].REALITEMFLAG) +
              Number(requesttype[0].COPYFLAG) +
              Number(requesttype[0].FILEFLAG);

            if (FlagNDDCOUNTOPEN > 0) {
              const modalRef = this.modalService.open(RdDialogComponent, {  size: 'md'});
              modalRef.componentInstance.dataRD = item;
              modalRef.componentInstance.mattypeID = this.mattypeID;
            } else {
              Swal.fire({
                icon: 'warning',
                title: `${item.ITEMID} ${msgRDClose}`,
                // text: `${item.ITEMID} ${msgRDClose}`,
              });
            }
          });
      }
    }
  }

  CheckNDDTypeOpen(locationidList: string) {
    return new Promise<boolean>((resolve, reject) => {
      this.NDDTypeOpenSubcription = this.memberService
        .NDDTypeOpen(locationidList)
        .pipe(
          switchMap(async (res: any) => {
            switch (res.status) {
              case 200:
                resolve(res.body.NDDtypeOpen);
                break;
              default:
                reject(null);
                break;
            }
          }),
          catchError((e) => {
            reject(null);

            return of([]);
          })
        )
        .subscribe();
    });
  }

  CheckNDDTypeOpenForArticle() {
    this.NDDTypeOpenSubcription = this.homeService
    .getNDDRequestTypeOpen('')
    .subscribe(async (requesttype: any) => {

      this.NDDForArticle = {
        FILEFLAG: requesttype[0].fileflag,
        COPYFLAG: requesttype[0].copyflag,
        REALITEMFLAG: requesttype[0].realitemflag,
        ITEMID: this.item,
        PAGE: '',
        PAGECOUNT: 0,
        LOCATIONID: ''
      }

      let _FlagNDDCOUNTOPENForArticle =
        Number(this.NDDForArticle.REALITEMFLAG) +
        Number(this.NDDForArticle.COPYFLAG) +
        Number(this.NDDForArticle.FILEFLAG);

      if (_FlagNDDCOUNTOPENForArticle > 0) {
        this.NDDTypeOpen = true;
        this.isArticle = true;
      } else {
        this.NDDTypeOpen = false;
      }

     // this.checkpenByCollection();
    });
  }

}
